import { render, staticRenderFns } from "./DirectionAndProject.vue?vue&type=template&id=67948ce9&"
import script from "./DirectionAndProject.vue?vue&type=script&lang=ts&"
export * from "./DirectionAndProject.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports